import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { IonIcon, IonSpinner } from '@ionic/react'
import { flash } from 'ionicons/icons'

import { Button } from '@components/atoms/Button'
import { VotingStatus } from '@components/atoms/VoteButton/hooks'

export interface IVoteButtonBaseProps {
  status: VotingStatus
  onVote: () => void
}

const VoteButtonBaseComponent: FC<IVoteButtonBaseProps> = ({
  status,
  onVote,
}) => {
  const { t } = useTranslation('common')

  switch (status) {
    case VotingStatus.Loading:
      return (
        <div className="w-sm rounded-full overflow-hidden m-1">
          <Button className="m-0" expand="block" type="tertiary">
            <IonSpinner name="dots" slot="icon-only" className={'text-black'} />
          </Button>
        </div>
      )
    case VotingStatus.NoVotes:
      return (
        <Button
          expand="block"
          type="secondary"
          size="default"
          className="w-sm"
          onClick={(e) => {
            e.stopPropagation()
            onVote()
          }}
        >
          <IonIcon icon={flash} slot="start" />
          {t('vote.outOfVotes')}
        </Button>
      )
    case VotingStatus.Voted:
      return (
        <Button expand="block" type="secondary" className="w-sm">
          <IonIcon icon={flash} slot="start" />
          {t('vote.unavailable')}
        </Button>
      )
    case VotingStatus.Open:
      return (
        <Button
          expand="block"
          className="w-sm"
          onClick={(e) => {
            e.stopPropagation()
            onVote()
          }}
        >
          <IonIcon icon={flash} slot="start" />
          {t('vote.available')}
        </Button>
      )
    default:
      return null
  }
}

export const VoteButtonBase = memo(VoteButtonBaseComponent)
